// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root___M7Z4","label":"Completed_label__VvT31"};